import { render, staticRenderFns } from "./Expert2OrganizationEditModal.vue?vue&type=template&id=1a5ff370&scoped=true&"
import script from "./Expert2OrganizationEditModal.vue?vue&type=script&lang=js&"
export * from "./Expert2OrganizationEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ff370",
  null
  
)

export default component.exports